import PropTypes from 'prop-types';
import React from 'react';
import { EditableTableCell } from 'components/EditableTable';
import cx from 'classnames';
import inputStyles from 'styles/input.scss';
import S from 'styles/table.scss';

const InputNote = (
  { value, label, onChange, cellValue, type, className, cellReadOnly },
) => {
  const cellVal = (value === null || cellValue === null) ? '' : cellValue || value;
  const cellProps = { label, onChange, value: cellVal, cellReadOnly };
  return (
    <EditableTableCell {...cellProps}>
      <input
        type={type}
        value={value === null ? '' : value}
        className={cx(inputStyles.inputElement, S.input, className)}
      />
    </EditableTableCell>
  );
};

InputNote.defaultProps = {
  cellValue: '',
  display: true,
  type: 'text',
  className: '',
  cellReadOnly: false,
};

InputNote.propTypes = {
  display: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cellValue: PropTypes.node,
  type: PropTypes.string,
  className: PropTypes.string,
  cellReadOnly: PropTypes.bool,
};

export default InputNote;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/inputNote.jsx